import React from 'react';
import styled from 'styled-components';
import {CSS_CONSTANTS} from '../../../../css_variables';
import placeholderAvatarBackground from '../../../../images/components/scheduling/placeholder-avatar-background.svg';

const Avatar = styled.div`
	background: url(${placeholderAvatarBackground}) center no-repeat;
	justify-content: center;
	align-items: center;
	display: flex;
	width: 28px;
	height: 32px;
`;

const Initials = styled.div`
	color: ${CSS_CONSTANTS.brand500};
	font-weight: 700;
	text-transform: uppercase;
	font-size: 14px;
`;

interface PlaceholderInitialsProps {
	initials: string;
}
export const PlaceholderInitials = ({initials}: PlaceholderInitialsProps): React.JSX.Element => {
	return (
		<Avatar>
			<Initials>{initials}</Initials>
		</Avatar>
	);
};
